import { useMemo, useState } from 'react';
import { map, range, pipe } from 'remeda';
import type { UseCalculateItemsProps } from './_props';

export default function useCalculateItems({
  getStartIndexOffset,
  getStopIndexOffset,
  containerHeight: height,
  containerWidth: width,
  totalItemsCount,
  eachItemSize,
  paintedItemsAfterOverflow,
  children,
}: UseCalculateItemsProps) {
  const [scrollTop, setScrollTop] = useState(0);
  const visibleItemCount = Math.ceil(height / eachItemSize);
  const totalHeight = totalItemsCount * eachItemSize;
  const startIndex = getStartIndexOffset({ scrollTop, eachItemSize });
  const endIndex = getStopIndexOffset({
    startIndex,
    visibleItemCount,
    totalItemsCount,
    paintedItemsAfterOverflow,
  });

  const items = useMemo(
    () =>
      pipe(
        range(startIndex, endIndex),
        map((itemIndex) =>
          children({
            index: itemIndex,
            style: {
              position: 'absolute',
              height: eachItemSize,
              width,
              top: itemIndex * eachItemSize,
            },
          }),
        ),
      ),
    [startIndex, endIndex, children, width, eachItemSize],
  );

  return {
    setScrollTop,
    totalHeight,
    items,
  };
}
